import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = { size?: Unit; color?: string };
export const Check = ({ size = 2, color = '#101010' }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 13"
      fill="none"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4144 3.41436L6.00015 12.8286L0.585938 7.41436L3.41436 4.58594L6.00015 7.17172L12.5859 0.585938L15.4144 3.41436Z"
        fill={color}
      />
    </svg>
  );
};
